import {HttpClient} from "@angular/common/http"
import {Injectable} from "@angular/core"
import {Router} from "@angular/router"
import {Observable} from "rxjs"
import {UserConfig} from "app/common/services/current-user/models/UserConfig"

@Injectable({providedIn: "root"})
export class AuthService {

    public constructor(private http: HttpClient) {
    }

    public logIn(email: string, password: string): Observable<any> {
        const url = `/tradefloor/public_api/login`
        const request = {username: email, password, broker: "IINVEST"}
        return this.http.post(url, request)
    }

    public retrieveUserConfig(): Observable<UserConfig> {
        const url = `/tradefloor/api/user/current-config`
        return this.http.get<UserConfig>(url)
    }

    public logOut(): Observable<void> {
        const url = "/tradefloor/api/logout"
        return this.http.post<void>(url, null)
    }
}
